import styled from 'styled-components';

type WrapperProps = {
  ctaLink: string;
};
export const Wrapper = styled.div<WrapperProps>`
  width: 80%;
  display: flex;
  align-items: center;
  cursor: ${props => (props.ctaLink ? 'pointer' : 'default')};
  padding-bottom: 8px;
`;

export const ArrowIcon = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const Decorate = styled.div<WrapperProps>`
  text-decoration: ${props => (props.ctaLink ? 'underline' : 'default')};
  text-underline-offset: 2px;
`;
